import {useCallback} from 'react';
import toast from 'react-hot-toast';

export const useRoomActions = ({
                                   sendMessage, disconnect, navigate, clearUser,
                                   roomCode, setCopiedCode, setSettings, userId,
                                   onClearHistory
                               }) => {
    const leaveRoom = useCallback(() => {
        if (window.confirm('Are you sure you want to leave this room?')) {

            sendMessage({
                type: 'user_leaving',
                user_id: userId,
                room_code: roomCode,
                timestamp: new Date().toISOString()
            });

            setTimeout(() => {
                disconnect();
                toast.success(
                    'Left room',
                    {position: 'bottom-center'}
                );
                navigate('/lobby');
            }, 100);
        }
    }, [sendMessage, disconnect, navigate, roomCode, userId]);

    const handleLogout = useCallback(() => {
        if (window.confirm('Are you sure you want to logout?')) {
            sendMessage({
                type: 'logout',
                roomCode, userId,
                timestamp: new Date().toISOString()
            });

            setTimeout(() => {
                disconnect();
                clearUser();
                toast.success('Logged out', {position: 'bottom-center'});
                navigate('/');
            }, 100);
        }
    }, [sendMessage, disconnect, clearUser, navigate, roomCode, userId,]);

    const updateSettings = useCallback((newSettings) => {
        setSettings((prev) => ({...prev, ...newSettings}));
        toast.success('Settings updated', {duration: 1500, position: 'bottom-center'});
    }, [setSettings]);

    const copyRoomCode = useCallback(() => {
        navigator.clipboard.writeText(roomCode)
            .then(() => {
                setCopiedCode(true);
                toast.success('Room code copied!', {duration: 1500});
                setTimeout(() => setCopiedCode(false), 2000);
            })
            .catch(err => {
                console.error('Failed to copy:', err);
                toast.error('Failed to copy room code');
            });
    }, [roomCode, setCopiedCode]);

    const clearHistory = useCallback(() => {
        if (onClearHistory) {
            onClearHistory();
        }
    }, [onClearHistory]);

    return {leaveRoom, handleLogout, updateSettings, copyRoomCode, clearHistory};
};
